import React from 'react';

import {
    Div,
    Group, Header,
    ModalRoot,
    Button,
    SplitCol,
    SplitLayout
} from '@vkontakte/vkui';

import {

    Icon20Users3,
    Icon20MarketOutline,
    Icon20CommentAddBadgeOutline,
    Icon20ListPenOutline,

    Icon20PinDotOutline,
    Icon20LocationMapOutline,
    Icon20DownloadOutline,
    Icon20UserCheckOutline
} from "@vkontakte/icons";

import {AdaptivityContext, isTradeDesigner} from "./assets/constants";

import BaseComponent from "./components/BaseComponent";
import { OfflineProvider } from "./contexts/OfflineContext";
import OfflineToggle from "./components/OfflineToggle";
import HelpButton from "./assets/HelpButton";


class References extends BaseComponent {

    constructor(props) {
        super(props);
        const savedOfflineMode = localStorage.getItem('scladro_offline_mode');
        const isOffline = savedOfflineMode ? JSON.parse(savedOfflineMode) : false;
        
        this.state = {
            ...this.state,
            offlineSyncLoading: false,
            isOffline: isOffline
        };
    }

    componentDidMount() {
        super.componentDidMount();
        window.addEventListener('message', this.handleSyncComplete);
        window.addEventListener('scladro_offline_change', this.handleOfflineChange);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        window.removeEventListener('message', this.handleSyncComplete);
        window.removeEventListener('scladro_offline_change', this.handleOfflineChange);
    }

    handleOfflineChange = (event) => {
        this.setState({ isOffline: event.detail.isOffline });
    }

    handleSyncComplete = (event) => {
        if (event.data === 'offlineSyncComplete') {
            this.setState({ offlineSyncLoading: false });
            window.postMessage({ type: 'success', text: 'Данные успешно обновлены для offline режима', timeout: 3000, hideSpinner: true });
        }
    }

    startOfflineSync = () => {
        this.setState({ offlineSyncLoading: true });
        window.postMessage('forceOfflineSync');
        
        // Таймаут на случай если событие не придёт (например, нет данных для синхронизации)
        setTimeout(() => {
            if (this.state.offlineSyncLoading) {
                this.setState({ offlineSyncLoading: false });
                window.postMessage({ type: 'success', text: 'Данные успешно обновлены для offline режима', timeout: 3000, hideSpinner: true });
            }
        }, 10000);
    }

    render() {


        const main_modals =
            <ModalRoot activeModal={this.state.activeModal}>

            </ModalRoot>;
        const isDesigner = isTradeDesigner(this.props.current_user)

        return (this.props.current_user &&
            <OfflineProvider>
                <Div>
                    <SplitLayout modal={main_modals}>
                        <SplitCol>
                            <Header>Адресная программа</Header>
                            <OfflineToggle />

                            {!isDesigner && <Group className="main-element bordered" header={<Header mode="secondary">Документы</Header>}>
                                <div key="goReferences6"
                                     className={'main-page ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}>
                                    <div className="main-page-button orange" href="#" data-story="sale_point_monitoring_story"
                                         onClick={(event) => {
                                             event.preventDefault();
                                             this.props.changeStory(event)
                                         }}>
                                        <Icon20PinDotOutline width={60} height={60}/>
                                        <p className="main-page-button_text">Мониторинг торговых точек</p>
                                    </div>
                                </div>
                            </Group>}
                            {!isDesigner && <Group className="main-element bordered" header={<Header mode="secondary">Отчеты</Header>}>
                                <div key="goReferences7"
                                     className={'main-page ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}>
                                    <div className="main-page-button" href="#" data-story="sale_point_map_story"
                                         onClick={(event) => {
                                             event.preventDefault();
                                             this.props.changeStory(event)
                                         }}>
                                        <Icon20LocationMapOutline width={60} height={60}/>
                                        <p className="main-page-button_text">Карта</p>
                                    </div>
                                    {(this.props.current_user && this.props.current_user.address_program == '1'
                                            && this.props.current_user.position_id == '3') &&
                                    <div className="main-page-button" href="#" data-story="datalens_export_story"
                                         onClick={(event) => {
                                             event.preventDefault();
                                             this.props.changeStory(event)
                                         }}>
                                        <Icon20DownloadOutline width={60} height={60}/>
                                        <p className="main-page-button_text">Экспорт DataLens</p>
                                    </div>}
                                </div>
                            </Group>}
                            <Group className="main-element bordered" header={<Header mode="secondary">Справочники</Header>}>
                                {!this.state.isOffline && (
                                    <Div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px'}}>
                                        <Button 
                                            size="l"
                                            stretched
                                            mode="commerce"
                                            loading={this.state.offlineSyncLoading}
                                            before={<Icon20DownloadOutline width={24} height={24}/>}
                                            onClick={this.startOfflineSync}
                                        >
                                            Обновить данные для offline
                                        </Button>
                                        <HelpButton text="Данная кнопка позволяет скачать и сохранить данные по стендам и коллекциям для работы offline, то есть без связи с интернетом"/>
                                    </Div>
                                )}

                                <div key="goReferences1"
                                     className={'main-page ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}>


                                    {!isDesigner && <div className="main-page-button" href="#" data-story="klients_story"
                                                         onClick={(event) => {
                                                             event.preventDefault();
                                                             this.props.changeStory(event)
                                                         }}>
                                        <Icon20Users3 width={60} height={60}/>
                                        <p className="main-page-button_text">Клиенты</p>
                                    </div>}
                                    {!isDesigner && <div className="main-page-button" href="#" data-story="staff_story"
                                                         onClick={(event) => {
                                                             event.preventDefault();
                                                             this.props.changeStory(event)
                                                         }}>
                                        <Icon20UserCheckOutline width={60} height={60}/>
                                        <p className="main-page-button_text">Сотрудники ТТ</p>
                                    </div>}
                                    <div className="main-page-button" href="#" data-story="salepoints_story"
                                         onClick={(event) => {
                                             event.preventDefault();
                                             this.props.changeStory(event)
                                         }}>
                                        <Icon20PinDotOutline width={60} height={60}/>
                                        <p className="main-page-button_text">Торговые точки</p>
                                    </div>

                                    <div className="main-page-button" href="#" data-story="malls_story"
                                         onClick={(event) => {
                                             event.preventDefault();
                                             this.props.changeStory(event)
                                         }}>
                                        <Icon20MarketOutline width={60} height={60}/>
                                        <p className="main-page-button_text">Торговые объекты</p>
                                    </div>
                                    {!isDesigner && <div className="main-page-button" href="#" data-story="stands_story"
                                                         onClick={(event) => {
                                                             event.preventDefault();
                                                             this.props.changeStory(event)
                                                         }}>
                                        <Icon20CommentAddBadgeOutline width={60} height={60}/>
                                        <p className="main-page-button_text">Стенды</p>
                                    </div>}
                                    {!isDesigner && <div className="main-page-button" href="#" data-story="standcollections_story"
                                                         onClick={(event) => {
                                                             event.preventDefault();
                                                             this.props.changeStory(event)
                                                         }}>
                                        <Icon20ListPenOutline width={60} height={60}/>
                                        <p className="main-page-button_text">Коллекции</p>
                                    </div>}
                                    {!isDesigner && <div className="main-page-button" href="#"
                                                         data-story="stand_collection_bindings_story"
                                                         onClick={(event) => {
                                                             event.preventDefault();
                                                             this.props.changeStory(event)
                                                         }}>
                                        <Icon20ListPenOutline width={60} height={60}/>
                                        <p className="main-page-button_text">Привязки товаров</p>
                                    </div>}
                                    {/*                            <div className="main-page-button" href="#" data-story="equipment_story"
                                     onClick={(event) => {
                                         event.preventDefault();
                                         this.props.changeStory(event)
                                     }}>
                                    <Icon20CheckNewsfeedOutline width={60} height={60}/>
                                    <p className="main-page-button_text">Стенды</p>
                                </div>*/}
                                </div>


                            </Group>
                        </SplitCol>
                    </SplitLayout>
                </Div>
            </OfflineProvider>

        );
    }

}

export default References;
